
































































import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import authModule from '@/store/auth'
import userModule from '@/store/user'
import dealModule from '@/store/deal'
import { Category } from '@/types/Types'
import { CategoryType } from '@/utils/enums'

@Component({
  name: 'CategoryEditor'
})
class CategoryEditor extends Vue {
  private categories: Category[] = []

  private get deals() {
    return dealModule.deals
  }

  private get localCategories(): Category[] {
    return this.categories.filter(
      category => category.type === CategoryType.LOCAL
    )
  }

  private get onlineCategories(): Category[] {
    return this.categories.filter(
      category => category.type === CategoryType.ONLINE
    )
  }

  private async created() {
    const { data } = await axios.get('/categories')
    // adds a flag to show active/inactive categories
    this.categories = data.categories.map((cat: Category) => ({
      ...cat,
      checked: authModule.user!.categories.includes(cat._id)
    }))
  }

  private get isValidForm(): boolean {
    const categoriesChanged =
      JSON.stringify(this.selectedCategories) !==
      JSON.stringify(authModule.user!.categories)

    const selectedLocalCategories = this.categories.filter(
      (category: any) =>
        category.type === CategoryType.LOCAL && category.checked
    )

    const selectedOnlineCategories = this.categories.filter(
      (category: any) =>
        category.type === CategoryType.ONLINE && category.checked
    )

    return (
      selectedLocalCategories.length >= 3 &&
      selectedOnlineCategories.length >= 3 &&
      categoriesChanged
    )
  }

  private get selectedCategories() {
    return this.categories.filter((el: any) => el.checked).map(el => el._id)
  }

  private saveCategories(): void {
    userModule.update({
      categories: this.selectedCategories
    })
  }
}
export default CategoryEditor
